exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-wrap{width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.8);z-index:2}.popup{width:137.386px;width:8.586667rem;height:137.386px;height:8.586667rem;top:50%;left:50%;margin:-95.2px 0 0 -68.64px;margin:-5.95rem 0 0 -4.29rem}.popup,.popup .close-btn{background-size:100% 100%}.popup .close-btn{width:18.133px;width:1.133333rem;height:10.666px;height:.666667rem;top:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0aa72b30","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/components/common/alert/index.vue
// module id = 9MWc
// module chunks = 0